"use client";

import { useMutation } from "@tanstack/react-query";
import type { PractitionerSearchDto } from "cmw-client";
import { browserCmw } from "@/lib/ky/browser";

/**
 * The search endpoint turns a sentence into a filter object and nothing more. The
 * caller pushes the filters into the directory state as if the controls had been
 * used, and the existing directory query lists from them, so pagination, the map
 * and the URL all keep working untouched.
 */
export function useLlmFilterSearch(
  onFilters: (result: PractitionerSearchDto) => void,
  takeTurnstileToken: () => Promise<string>,
) {
  const mutation = useMutation({
    mutationFn: async (query: string) =>
      browserCmw.practitionersPublic.search({ query }, await takeTurnstileToken()),
    onSuccess: onFilters,
  });

  return {
    search: (query: string) => mutation.mutate(query),
    result: mutation.data,
    isSearching: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
